// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entery-name[data-v-3105e652]{color:#3168ff!important}", ""]);
// Exports
module.exports = exports;
